import { PersonOutlined } from "@mui/icons-material";
import "./Layout.css";
import { Link, Outlet } from "react-router-dom";
import { UserButton, SignedIn, SignedOut, SignInButton } from "@clerk/clerk-react";

export default function Layout(){
    return(
    <div>
        <div className="nav">
                <div className="nav_parent">
                    <Link to="/">
                        <div className="nav_hero">
                            JOB SNIPER
                        </div>
                    </Link>
                    <div className="nav_links">
                        <Link to="/">
                            <div className="grad_button">Home</div>
                        </Link>
                        <Link to="/profile">
                            <div className="grad_button">You</div>
                        </Link>
                        <Link to="/analyzer">
                            <div className="grad_button">Analyzer</div>
                        </Link>
                        <SignedIn>
                            <UserButton afterSignOutUrl="/" />
                        </SignedIn>
                        <SignedOut>
                            <SignInButton mode="modal">
                                <div className="login_button">
                                    <PersonOutlined />
                                </div>
                            </SignInButton>
                        </SignedOut>
                </div>
            </div>
        </div>
    <Outlet />
    </div>
    )
}